import { render, staticRenderFns } from "./ybd.vue?vue&type=template&id=4b23b929"
import script from "./ybd.vue?vue&type=script&lang=js"
export * from "./ybd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports